import React from "react";
import { createRoot } from "react-dom/client";
import "flare-ui/styles.css";
// Initialize i18next before the React tree mounts so the first render uses the
// locale selected by the URL or persisted preference.
import "@/i18n";
import { App } from "@/app/app";

// Tokens and semantic themes load before shared primitives and local owners.
import "@/styles/tokens.css";
import "@/styles/themes.css";
import "@/styles/base.css";
import "@/styles/layout.css";
import "@/styles/motion.css";

createRoot(document.getElementById("root")!).render(<App />);
